// 処方の読み (Kakeru Education 1st step・ティーチングモード) の envelope 型。
// back: GET/POST /api/education/<yakureki_id>/prescription-reading/
// AI の読み（講評）は薬剤師本人の読みに依存するため、生成は POST(提出) で駆動する。
// GET は現在状態を返すのみ。status field で分岐する。

export type PrescriptionReadingStatus =
  | 'awaiting_input'
  | 'processing'
  | 'completed'
  | 'failed'
  | 'skipped'

// AI の講評本文に埋め込まれた引用マーカー [1] 等と、その出典の対応。
export interface Citation {
  marker: string
  source: string
}

// まだ読みが提出されていない (= 入力受付) 状態。
export interface AwaitingInputResponse {
  status: 'awaiting_input'
}

export interface ProcessingResponse {
  status: 'processing'
}

export interface CompletedResponse {
  status: 'completed'
  data: {
    // AI の講評（薬剤師の読みへの返し）。
    reading: string
    citations: Citation[]
    // 講評の対象になった薬剤師本人の読み。
    selfReading: string
  }
}

export interface FailedResponse {
  status: 'failed'
  error: {
    message: string
  }
}

// skipped は状態シグナルのみ。表示文言は front が所有する。
export interface SkippedResponse {
  status: 'skipped'
}

export type PrescriptionReadingResponse =
  | AwaitingInputResponse
  | ProcessingResponse
  | CompletedResponse
  | FailedResponse
  | SkippedResponse

const hasStringStatus = (
  v: unknown,
  expected: PrescriptionReadingStatus
): v is { status: PrescriptionReadingStatus } =>
  typeof v === 'object' &&
  v !== null &&
  'status' in v &&
  (v as { status: unknown }).status === expected

export const isAwaitingInputResponse = (
  v: unknown
): v is AwaitingInputResponse => hasStringStatus(v, 'awaiting_input')

export const isProcessingResponse = (v: unknown): v is ProcessingResponse =>
  hasStringStatus(v, 'processing')

export const isCompletedResponse = (v: unknown): v is CompletedResponse =>
  hasStringStatus(v, 'completed')

export const isFailedResponse = (v: unknown): v is FailedResponse =>
  hasStringStatus(v, 'failed')

export const isSkippedResponse = (v: unknown): v is SkippedResponse =>
  hasStringStatus(v, 'skipped')
